<ng-container *ngIf="selectedAction == 'manage-category'">
    <app-manage-region [manageRegionData]="manageRegionData" (categoryResponseEvent)="receiveRegionResponse($event)" />
</ng-container>
<ng-container *ngIf="selectedAction == 'view-all'">
<div class="card-body flex justify-between flex-wrap gap-3">
    <div>
        <input type="text" id="input-label-with-helper-text"
            class="py-3 px-4 text-gray-500 block w-full border-gray-200 rounded-sm text-sm focus:border-blue-600 focus:ring-0 "
            placeholder="search" aria-describedby="hs-input-helper-text">
    </div>
    <button type="button" (click)="selectRegionAction('add')"
        class="py-2 px-6 btn rounded-2xl text-base font-medium border border-transparent bg-blue-600 text-white hover:bg-blue-700">
        Add Region
    </button>

</div>

<div class="card">
    <div class="card-body">
        <h6 class="text-lg text-gray-500 font-semibold mb-6">Regions Configurations</h6>
        <app-preloader *ngIf="loading"></app-preloader>
        <div class="relative overflow-x-auto" *ngIf="!loading">
            <table class="text-left w-full whitespace-nowrap text-sm text-gray-500">
                <thead>
                    <tr class="text-sm">
                        <th scope="col" class="p-4 font-semibold">Label</th>
                        <th scope="col" class="p-4 font-semibold">Order</th>
                        <th scope="col" class="p-4 font-semibold">Value</th>
                        <th scope="col" class="p-4 font-semibold">Description</th>
                        <th scope="col" class="p-4 font-semibold">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let region of regions">
                        <td class="p-4 text-sm">
                            <div class="flex gap-6 items-center">
                                <div class="flex flex-col gap-1 text-gray-500">
                                    <h3 class=" font-bold">{{ region.label }}</h3>
                                </div>
                            </div>
                        </td>
                        <td class="p-4">
                            <h3 class="font-medium">{{ region.order}}</h3>
                        </td>
                        <td class="p-4">
                            <h3 class="font-medium">{{ region.value}}</h3>
                        </td>
                        <td class="p-4">
                            <h3 class="font-medium">{{ region.description}}</h3>
                        </td>
                        <td>
                            <div
                                class="hs-dropdown relative inline-flex [--placement:bottom-left] sm:[--trigger:hover]">
                                <a class="relative hs-dropdown-toggle inline-flex hover:text-gray-500 text-gray-300"
                                    href="javascript:void(0);">
                                    <i class="ti ti-dots-vertical text-xl relative z-[1]"></i>
                                </a>
                                <div class="card hs-dropdown-menu transition-[opacity,margin] rounded-md duration hs-dropdown-open:opacity-100 opacity-0 mt-2 min-w-max  w-[100px] hidden z-[12]"
                                    aria-labelledby="hs-dropdown-custom-icon-trigger">
                                    <div>
                                        <ul class="list-none  flex flex-col">
                                            <li>
                                                <a href="javascript:void(0);" class="py-3 px-6 block hover:bg-gray-200">
                                                    <i class="ti ti-eye"></i> View
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" (click)="selectRegionAction('edit', region)" class="py-3 px-6 block hover:bg-gray-200">
                                                    <i class="ti ti-pencil"></i> Edit
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);" (click)="triggerDelete(region)"
                                                    class="py-3 px-6 block hover:bg-gray-200">
                                                    <i class="ti ti-trash"></i> Delete
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</ng-container>